import React, { useState } from 'react';
import { TextField, Button, Typography, Box } from '@mui/material';
import Grid from '@mui/material/Grid2';
import axios from 'axios';
import { Theme } from '../../components/Theme';
import { Link as RouterLink, useSearchParams, useNavigate } from 'react-router-dom';

export default function ResetPassword() {
    const [input, setInput] = useState({
        email: '',
        password: '',
        confirmPassword: ''
    });
    const [message, setMessage] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const code = searchParams.get('code');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInput((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (input.password !== input.confirmPassword) {
            setIsSuccess(false);
            setMessage('Las contraseñas no coinciden.');
            return;
        }

        try {
            const response = await axios.post('/api/account/reset-password', {
                email: input.email,
                password: input.password,
                code: code
            });
            
            if (response.status === 200) {
                setIsSuccess(true);
                setMessage('Su contraseña ha sido restablecida con éxito.');
                // Redirect to login page after 3 seconds
                setTimeout(() => {
                    navigate('/');
                }, 3000);
            }
        } catch (error) {
            setIsSuccess(false);
            setMessage('No se pudo restablecer la contraseña. Por favor, intente nuevamente.');
            console.error('Reset password error:', error);
        }
    };

    if (!code) {
        return (
            <Theme>
                <Box sx={{ 
                    p: 2,
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <Typography color="error">
                        Enlace de restablecimiento de contraseña inválido.
                    </Typography>
                </Box>
            </Theme>
        );
    }

    return (
        <Theme>
            <Box 
                sx={{ 
                    p: 2,
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <Box sx={{ maxWidth: 400, width: '100%' }}>
                    <Typography variant="h4" gutterBottom>
                        Restablecer contraseña
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 12 }}>
                            {message && (
                                <Typography 
                                    color={isSuccess ? "success" : "error"} 
                                    gutterBottom
                                >
                                    {message}
                                </Typography>
                            )}
                            <form onSubmit={handleSubmit} name="reset-password">
                                <Typography variant="body1" gutterBottom>
                                    Ingrese su correo electrónico y nueva contraseña.
                                </Typography>
                                <Grid container spacing={2}>
                                    <Grid size={{ xs: 12 }}>
                                        <TextField
                                            variant="standard"
                                            fullWidth
                                            label="Correo electrónico"
                                            placeholder="name@example.com"
                                            name="email"
                                            value={input.email}
                                            onChange={handleChange}
                                            autoComplete="email"
                                            required
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12 }}>
                                        <TextField
                                            variant="standard"
                                            fullWidth
                                            label="Nueva contraseña"
                                            placeholder="Ingrese su nueva contraseña"
                                            name="password"
                                            type="password"
                                            value={input.password}
                                            onChange={handleChange}
                                            autoComplete="new-password"
                                            required
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12 }}>
                                        <TextField
                                            variant="standard"
                                            fullWidth
                                            label="Confirmar contraseña"
                                            placeholder="Confirme su nueva contraseña"
                                            name="confirmPassword"
                                            type="password"
                                            value={input.confirmPassword}
                                            onChange={handleChange}
                                            autoComplete="new-password"
                                            required
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12 }}>
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                        >
                                            Restablecer contraseña
                                        </Button>
                                    </Grid>
                                </Grid>
                            </form>
                            <Grid container spacing={2} sx={{ mt: 2 }}>
                                <Grid xs={12}>
                                    <RouterLink 
                                        to="/"
                                        style={{ color: 'primary' }}
                                    >
                                        Volver al inicio de sesión
                                    </RouterLink>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Theme>
    );
}
